import { POS_SCAN_KIND } from './posScanCode.js';

/** Message utilisateur pour un code scanné/saisi non GTIN produit (QR client, etc.). */
export function messageForNonRetailScanKind(kind) {
  switch (kind) {
    case POS_SCAN_KIND.CLICKORICO_CLIENT:
      return 'Ce code est un QR client Clickorico, pas un code-barres produit.';
    case POS_SCAN_KIND.CLICKORICO_PICKUP:
      return 'Ce code est un QR de retrait, pas un code-barres produit.';
    case POS_SCAN_KIND.UNKNOWN:
    default:
      return 'Code-barres invalide. Saisissez un EAN/GTIN (8, 12, 13 ou 14 chiffres).';
  }
}

function isNetworkError(err) {
  const msg = String(err?.message || '');
  return (
    err?.name === 'TypeError' ||
    msg.includes('Impossible de contacter le serveur') ||
    msg.includes('Délai d\'attente dépassé')
  );
}

/**
 * Message caisse pour échec lookup-barcode (API ou réseau).
 * @param {Error & { code?: string, status?: number }} err
 */
export function messageForBarcodeLookupError(err) {
  if (isNetworkError(err)) {
    return 'Connexion impossible. Vérifiez le réseau et réessayez.';
  }
  const code = err?.code;
  switch (code) {
    case 'BARCODE_NOT_FOUND':
      return 'Aucun produit trouvé pour ce code-barres. Utilisez la recherche catalogue.';
    case 'BARCODE_NOT_SELLABLE':
      return 'Ce produit n\'est pas vendable en caisse (inactif ou indisponible).';
    case 'BARCODE_AMBIGUOUS':
      return 'Code-barres ambigu dans la boutique — contactez le support.';
    case 'BARCODE_NEEDS_OPTIONS':
      return err.message || 'Complétez les options obligatoires sur la fiche produit.';
    case 'BARCODE_INVALID':
      return 'Code-barres invalide.';
    default:
      break;
  }
  if (err?.message) return err.message;
  return 'Aucun produit trouvé pour ce code-barres. Utilisez la recherche catalogue.';
}
